import gpay from "./gpay.png"
import phonepayIcon from "./phoepay.png"
import paytmIcon from "./paytm.png"
import fastbillinglogo from "./fastbillinglogo.png"
const Image = {

    gpay: gpay,
    phonepay: phonepayIcon,
    paytm: paytmIcon,
    fastbillinglogo: fastbillinglogo,
}
export default Image